export default __webpack_public_path__ + "static/media/right_arrow.d984495d.svg";